export default __webpack_public_path__ + "static/tecalis-students_06-4cf28c7ceb506511a1eedfe7546171af.png";